import React from "react";

/**
 * Material UI
 */
import { Box, Typography, Icon, IconButton, Tooltip, CircularProgress, ButtonBase } from '@material-ui/core';
import { makeStyles } from "@material-ui/styles";

const useActionButtonStyles = makeStyles((theme) => ({
    root: {
        display: 'inline-flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minWidth: 52,
        minHeight: 52,
        padding: theme.spacing(0.75, 1),
        margin: theme.spacing(0.25),
        borderRadius: theme.spacing(1.25),
        backgroundColor: `${theme.palette.background.paper}EE`,
        border: `1px solid ${theme.palette.divider}`,
        boxShadow: '0 1px 4px rgba(0,0,0,0.12)',
        WebkitTapHighlightColor: 'transparent',
        touchAction: 'manipulation',
        [theme.breakpoints.up('sm')]: {
            minWidth: 48,
            minHeight: 48,
        },
        '&:active': {
            backgroundColor: theme.palette.action.selected,
        },
        '&.Mui-disabled': {
            opacity: 0.55,
        },
    },
    icon: {
        fontSize: '1.45rem',
        color: theme.palette.primary.main,
        lineHeight: 1,
    },
    label: {
        marginTop: 2,
        fontWeight: 700,
        fontSize: '0.7rem',
        lineHeight: 1.1,
        color: theme.palette.text.primary,
        maxWidth: 56,
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
    },
}));

/** Shared touch-friendly action chip used by speak / dictionary controls. */
export const SelectionActionButton = (props) => {
    const classes = useActionButtonStyles();
    const { onClick, title, icon, label, disabled, loading } = props;
    return (
        <Tooltip title={title || ''}>
            <span>
                <ButtonBase
                    className={classes.root}
                    onClick={onClick}
                    disabled={disabled || loading}
                    aria-label={title || label}
                >
                    {loading ?
                        <CircularProgress size={22} color="primary" /> :
                        <Icon className={classes.icon}>{icon}</Icon>}
                    {Boolean(label) &&
                        <Typography className={classes.label} component="span">
                            {label}
                        </Typography>}
                </ButtonBase>
            </span>
        </Tooltip>
    );
};

export const SpeakButton = (props) => {
    const { onClick, languageText, languageName } = props;
    return (
        <SelectionActionButton
            title={`Speak in ${languageName}`}
            icon="record_voice_over"
            label={languageText}
            onClick={onClick}
        />
    );
};

export const StopButton = (props) => {
    const { onClick } = props;
    return (
        <SelectionActionButton
            title="Stop speaking"
            icon="stop"
            label="Stop"
            onClick={onClick}
        />
    );
};

/** Legacy small icon button kept for non-selection toolbars if needed. */
export const CompactIconButton = (props) => {
    const { onClick, title, icon, ...others } = props;
    return (
        <Tooltip title={title || ''}>
            <IconButton onClick={onClick} size="medium" {...others}>
                <Icon>{icon}</Icon>
            </IconButton>
        </Tooltip>
    );
};
